import React, {useEffect, useState} from 'react';
import _ from 'lodash';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';

export const SaveEntityListener = ({paths, saveEntityData, ...restProps}) => {
  useEffect(() => {
    _.forEach(paths, (path) => {
      const {pathToSet, entityType, valueToSet, valueToSetIsPath, pathToSetFrom} = path;

      if (valueToSetIsPath && pathToSetFrom) {
        saveEntityData(pathToSet, entityType, _.get(restProps, pathToSetFrom));
      } else {
        saveEntityData(pathToSet, entityType, valueToSet);
      }
    });
  }, []);
  return null;
};
export default connectDynamic(SaveEntityListener);
